import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, DateDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
export class OrganizationPaymentMandateDetails extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.cardExpiryDate = null;
        this.cardLabel = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true })
], OrganizationPaymentMandateDetails.prototype, "consumerName", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], OrganizationPaymentMandateDetails.prototype, "consumerAccount", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], OrganizationPaymentMandateDetails.prototype, "consumerBic", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], OrganizationPaymentMandateDetails.prototype, "cardExpiryDate", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], OrganizationPaymentMandateDetails.prototype, "cardLabel", void 0);
export class OrganizationPaymentMandate extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.isDefault = false;
        /**
         * The signature date of the mandate in YYYY-MM-DD format.
         */
        this.signatureDate = null;
        this.mandateReference = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], OrganizationPaymentMandate.prototype, "id", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], OrganizationPaymentMandate.prototype, "isDefault", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OrganizationPaymentMandate.prototype, "method", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OrganizationPaymentMandate.prototype, "status", void 0);
__decorate([
    field({ decoder: OrganizationPaymentMandateDetails })
], OrganizationPaymentMandate.prototype, "details", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], OrganizationPaymentMandate.prototype, "signatureDate", void 0);
__decorate([
    field({ decoder: DateDecoder })
], OrganizationPaymentMandate.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], OrganizationPaymentMandate.prototype, "mandateReference", void 0);
//# sourceMappingURL=OrganizationPaymentMandate.js.map